/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputChannelDefinitionItem
 */
export interface OutputChannelDefinitionItem {
    /**
     * 
     * @type {string}
     * @memberof OutputChannelDefinitionItem
     */
    band: string;
    /**
     * 
     * @type {string}
     * @memberof OutputChannelDefinitionItem
     */
    channel: string;
    /**
     * 
     * @type {number}
     * @memberof OutputChannelDefinitionItem
     */
    frequency: number;
}

/**
 * Check if a given object implements the OutputChannelDefinitionItem interface.
 */
export function instanceOfOutputChannelDefinitionItem(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('frequency' in value)) return false;
    return true;
}

export function OutputChannelDefinitionItemFromJSON(json: any): OutputChannelDefinitionItem {
    return OutputChannelDefinitionItemFromJSONTyped(json, false);
}

export function OutputChannelDefinitionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChannelDefinitionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'channel': json['channel'],
        'frequency': json['frequency'],
    };
}

export function OutputChannelDefinitionItemToJSON(value?: OutputChannelDefinitionItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'channel': value['channel'],
        'frequency': value['frequency'],
    };
}

